const SalesRegionToRepMap = new Map();

SalesRegionToRepMap.set("Karen Phillips", "Central");
SalesRegionToRepMap.set("RJ & Vern Lachowitzer", "Florida");
SalesRegionToRepMap.set("Phil Fowler", "Mid-Atlantic");
SalesRegionToRepMap.set("Patrick Shannahan", "Midwest");
SalesRegionToRepMap.set("Bill & Charlie Ryan", "New England");
SalesRegionToRepMap.set("Dave Hunt", "New York");
SalesRegionToRepMap.set("Mitch Pearson", "North Central");
SalesRegionToRepMap.set("Peter Ross", "Northern California");
SalesRegionToRepMap.set("Shaun Lowen", "Pacific Northwest");
SalesRegionToRepMap.set("Chris Cafasso", "South");
SalesRegionToRepMap.set("Rachel Hernandez", "South Central");
// SalesRegionToRepMap.set("Bob Ryan", "Southern California");
SalesRegionToRepMap.set("Gary & Kelsey Moretti", "Southwest");
SalesRegionToRepMap.set("Jeff Lynner", "Tri-State");
// SalesRegionToRepMap.set("Michael Urkowitz", "Virginia");
SalesRegionToRepMap.set("N/A", "Unassigned");

export default SalesRegionToRepMap;
